import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.GettingStartedPage.ConnectAccountingSystem', {
    title: 'Connect your accounting system',
    description:
        'Unlock AP and AR approval workflows by connecting your Xero, QuickBooks Online or NetSuite organisation.',
    buttonText: 'Connect',
});
